/**
 * @generated SignedSource<<d99da560bd3a721ea9b831ee39194ad9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UJStatuses = "OBSOLETE" | "PAUSED" | "RUNNING" | "%future added value";
export type selfServiceSettingsSetStatusMutation$variables = {
  status: UJStatuses;
  ujID: number;
};
export type selfServiceSettingsSetStatusMutation$data = {
  readonly setSelfServiceUJStatus: {
    readonly userJourney: {
      readonly " $fragmentSpreads": FragmentRefs<"selfServiceSettings_statusFragment">;
    } | null;
  } | null;
};
export type selfServiceSettingsSetStatusMutation = {
  response: selfServiceSettingsSetStatusMutation$data;
  variables: selfServiceSettingsSetStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ujID"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "ujID"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "kind": "ObjectValue",
    "name": "uj"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "selfServiceSettingsSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SetSelfServiceUJStatusMutation",
        "kind": "LinkedField",
        "name": "setSelfServiceUJStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserJourney",
            "kind": "LinkedField",
            "name": "userJourney",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "selfServiceSettings_statusFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "selfServiceSettingsSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SetSelfServiceUJStatusMutation",
        "kind": "LinkedField",
        "name": "setSelfServiceUJStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserJourney",
            "kind": "LinkedField",
            "name": "userJourney",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b763d22a06f8eb57abc30f81c76d665f",
    "id": null,
    "metadata": {},
    "name": "selfServiceSettingsSetStatusMutation",
    "operationKind": "mutation",
    "text": "mutation selfServiceSettingsSetStatusMutation(\n  $ujID: Int!\n  $status: UJStatuses!\n) {\n  setSelfServiceUJStatus(uj: {id: $ujID, status: $status}) {\n    userJourney {\n      ...selfServiceSettings_statusFragment\n      id\n    }\n  }\n}\n\nfragment selfServiceSettings_statusFragment on UserJourney {\n  id\n  status\n}\n"
  }
};
})();

(node as any).hash = "e5c7e639acd90ae5f6ffef459842d911";

export default node;
